import type { ComponentSchema } from "../../../../../schema-types";
import { SUPPORTED_PAGES, SECTION_STYLE_FIELDS } from "../../_builder-constants";

const POST_SCHEMA = [
  { key: "title", label: "Title", type: "string" as const },
  { key: "image", label: "Image", type: "image" as const },
  { key: "excerpt", label: "Excerpt", type: "text" as const },
  { key: "slug", label: "Slug", type: "string" as const },
  { key: "date", label: "Date", type: "string" as const },
  { key: "category", label: "Category", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "blog",
  label: "Blog Posts",
  description: "Display a grid or list of blog post cards.",
  supportedPages: [...SUPPORTED_PAGES],
  variants: [
    {
      id: "v1",
      label: "V1 — 3-Column Card Grid (Fashion Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: POST_SCHEMA },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: true },
      ],
    },
    {
      id: "v2",
      label: "V2 — List Style (Electronics Style)",
      fields: [
        { key: "title", label: "Section Title", type: "string" },
        { key: "posts", label: "Posts", type: "array", itemSchema: POST_SCHEMA },
        { key: "viewAllLink", label: "View All Link", type: "string" },
        { key: "showViewAll", label: "Show View All Button", type: "boolean", default: true },
      ],
    },
    {
      id: "v3",
      label: "Article Detail",
      fields: [],
    },
  ],
  commonFields: [
    { key: "source", label: "Posts to show", type: "select" as const, options: [{ label: "Live posts from the blog", value: "posts" }, { label: "Posts typed here", value: "manual" }], help: "Without a choice: typed posts when there are some, else the live blog." },
    ...SECTION_STYLE_FIELDS,
  ],
};
